import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { LegalDocumentInfoDto, LegalDocumentTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/useApiClient.util.ts';

type Return = {
  document?: LegalDocumentInfoDto;
  isLoading: boolean;
};

export const useCurrentLegalDocument = (documentType: LegalDocumentTypeDto): Return => {
  const { legalDocumentsApi } = useApiClient();

  const { data, isLoading } = useQuery<LegalDocumentInfoDto, AxiosError>({
    queryFn: async () => {
      const { data } = await legalDocumentsApi.getCurrentLegalDocument(documentType);
      return data;
    },
    queryKey: [QueryKeyEnum.LEGAL_DOCUMENT_CURRENT, documentType],
  });

  return {
    document: data,
    isLoading,
  };
};
